<template>
  <section class="page-section">
    <div class="container">
      <div class="row">
        <div class="col-md-12 ">
          <h1 class="section-title text-center">
            {{ $t('label.title.easyStep') }}
          </h1>
        </div>
        <div class="offset-md-2 col-md-8 offset-lg-3 col-lg-6 mb-5">
          <p class="text-center">
            {{ $t('label.subtitle.easyStep') }}
          </p>
        </div>
        <div class="col-md-12">
          <div class="row">
            <template v-for="(item, key) in steps">
              <div
                class="col-md-3"
                :key="key"
              >
                <home-easy-step-item :step="item" />
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import HomeEasyStepItem from '@/views/includes/home/includes/HomeEasyStepItem'
export default {
  name: 'HomeEasyStep',
  components: { HomeEasyStepItem },
  computed: {
    steps () {
      return [
        { title: this.$t('home.title.step1'), description: this.$t('home.description.step1'), color: '#3588f0', border_color: '#3588f0', number: this.$t('number.1') },
        { title: this.$t('home.title.step2'), description: this.$t('home.description.step2'), color: '#3588f0', border_color: '#3588f0', number: this.$t('number.2') },
        { title: this.$t('home.title.step3'), description: this.$t('home.description.step3'), color: '#05c36c', border_color: '#05c36c', number: this.$t('number.3') },
        { title: this.$t('home.title.step4'), description: this.$t('home.description.step4'), color: '#3588f0', border_color: '#3588f0', number: this.$t('number.4') }
      ]
    }
  }
}
</script>

<style scoped>

</style>
